import React, { createContext, useContext } from 'react';
import type { ITokenManager } from '@edusense/shared-types-auth';
import type { IIdeMessagingService } from '@edusense/shared-types-ide';
import type { INavigationService } from '@edusense/shared-types-navigation';
// StatusDisplay 제거 - FSD 아키텍처: shared layer에서 UI 컴포넌트 사용 금지

// 로컬 imports
import { ExtendedAuthContextType, TOKEN_KEY, USER_KEY, REFRESH_TOKEN_KEY, ID_TOKEN_KEY } from './types';
import { defaultAuthContext } from './default-auth-context';
import { useAuthProvider } from '../hooks/useAuthProvider';
import { AuthConfig } from '../types/auth-config';

export const AuthContext = createContext<ExtendedAuthContextType>(defaultAuthContext);

interface AuthProviderProps {
  children: React.ReactNode;
  config?: AuthConfig;
  ideMessagingService?: IIdeMessagingService;
  navigationService?: INavigationService;
  tokenManager?: ITokenManager;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ 
  children, 
  config,
  ideMessagingService,
  navigationService,
  tokenManager: injectedTokenManager
}) => {
  const contextValue = useAuthProvider({
    config,
    ideMessagingService,
    navigationService,
    tokenManager: injectedTokenManager
  });

  return (
    <AuthContext.Provider value={contextValue}>
      {/* FSD 아키텍처: 로딩 UI는 상위 레이어에서 contextValue.state.isLoading 확인하여 처리 */}
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): ExtendedAuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// 기본 exports
export { TOKEN_KEY, USER_KEY, REFRESH_TOKEN_KEY, ID_TOKEN_KEY } from './types';